module.exports = __webpack_public_path__ + "static/Group 36-e2d43e128e147876039cec28c93b38dd.svg";